import React from 'react'

import './style.scss'

const Switcher = ({children, threshold = 0, space = '1rem', className='', ...restOfProps}) => { 
    return (<div style={{"--threshold": threshold, "--space": space}} className={`nearst-layout__switcher ${className}`} {...restOfProps}>
    <div> 
      {children}
    </div>
  </div>)
}

export default Switcher;